export const formatNumber = (nbr: number) => nbr.toString().padStart(2, "0");

export const capitalizeFirstLetter = (str: string) =>
  String.fromCharCode(str.charCodeAt(0) & 223) + str.slice(1);
